import { useRegisterSW } from 'virtual:pwa-register/react';

export function UpdateBanner() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return;

      // Check for updates every 60 seconds
      setInterval(() => {
        registration.update();
      }, 60000);

      // Check for updates when user returns to tab
      const handleVisibilityChange = () => {
        if (!document.hidden) {
          registration.update();
        }
      };
      document.addEventListener(
        'visibilitychange',
        handleVisibilityChange
      );
    },
  });

  const handleRefresh = async () => {
    console.log(
      '[UpdateBanner] Refresh clicked, attempting SW update...'
    );
    try {
      await updateServiceWorker(true);
      console.log(
        '[UpdateBanner] updateServiceWorker() resolved'
      );
    } catch (err) {
      console.error(
        '[UpdateBanner] updateServiceWorker() failed:',
        err
      );
    }
    console.log('[UpdateBanner] Reloading page...');
    window.location.reload();
  };

  if (!needRefresh) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: '#667eea',
        color: 'white',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
      }}
    >
      <span style={{ fontSize: '14px', fontWeight: 500 }}>
        A new version is available
      </span>
      {/* eslint-disable-next-line custom-rules/prefer-button */}
      <button
        onClick={handleRefresh}
        style={{
          backgroundColor: 'white',
          color: '#667eea',
          border: 'none',
          borderRadius: '6px',
          padding: '6px 16px',
          fontSize: '14px',
          fontWeight: 600,
          cursor: 'pointer',
          transition: 'transform 0.1s',
        }}
        onMouseDown={e => {
          e.currentTarget.style.transform = 'scale(0.95)';
        }}
        onMouseUp={e => {
          e.currentTarget.style.transform = 'scale(1)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = 'scale(1)';
        }}
      >
        Refresh
      </button>
    </div>
  );
}
